import React from 'react';
import PropTypes from 'prop-types';
import GreenStar from '../../../../images/star_Green.png';
import Styles from './RatingCard.legacy.module.scss';

/**
 * The pre-GOTU-7339 rating card, restored from `b83c6bd9` for the GOTU-6266
 * flag-off path. `RatingDetails` renders two of these when the flag is off.
 *
 * One component served both sides by taking a `ratingItems` array, and the cost
 * showed on screen: the office side carried a `Rating` row with no value,
 * because the array had to fit a shape that side didn't have. GOTU-7339 split
 * it into `OfficeReviewCard` and `ProfessionalReviewCard` for exactly that
 * reason — this is kept only so the flag-off path renders what production
 * renders today, not as a pattern to follow. Delete it with the flag.
 *
 * Restored as-was apart from two things:
 *
 * - The inline styles and global classes moved into a co-located scss module,
 *   so the betterer trackers stay flat. Values are verbatim; see the module's
 *   header for the two classes that turned out to be dead.
 * - `ratingItems.map` had no `key`, so React warned and reused rows by index.
 *   Keyed on `label`, which is unique within a card.
 */
const RatingCardLegacy = ({ title, name, averageRating, ratingItems, feedback }) => (
  <div className={Styles.card}>
    <p className={Styles.title}>{title}</p>
    <div className={Styles.nameRow}>
      <p className={Styles.name}>{name}</p>
      <p className={Styles.average}>
        {averageRating ? (
          <>
            AVG <img src={GreenStar} className={Styles.star} alt="star_icon" />{' '}
            {averageRating?.toFixed(1)}
          </>
        ) : null}
      </p>
    </div>
    <div className={Styles.items}>
      {ratingItems.map((item) => (
        <div className={Styles.item} key={item.label}>
          <p>{item.label}</p>
          <p>{item.value}</p>
        </div>
      ))}
    </div>
    <div className={Styles.feedback}>
      <p className={Styles.feedbackLabel}>Confidential Feedback for GoTu</p>
      <span>{feedback?.trim() || 'N/A'}</span>
    </div>
  </div>
);

RatingCardLegacy.propTypes = {
  /** The `DENTIST` / `DENTAL PROFESSIONAL` eyebrow the revamp drops. */
  title: PropTypes.string,
  name: PropTypes.string,
  /** Rendered as `AVG ★ n.n`, and only when truthy — a 0 shows nothing. */
  averageRating: PropTypes.number,
  ratingItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  feedback: PropTypes.string,
};

RatingCardLegacy.defaultProps = {
  title: '',
  name: '',
  averageRating: undefined,
  ratingItems: [],
  feedback: '',
};

export { RatingCardLegacy };
export default RatingCardLegacy;
